import { render, staticRenderFns } from "./addmedical.vue?vue&type=template&id=2aef004c&scoped=true&"
import script from "./addmedical.vue?vue&type=script&lang=js&"
export * from "./addmedical.vue?vue&type=script&lang=js&"
import style0 from "./addmedical.vue?vue&type=style&index=0&id=2aef004c&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aef004c",
  null
  
)

export default component.exports